import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { FluidContainer } from '@atlassian/mpac-primitives';
import { ResponsiveTabs, useParams } from '@atlassian/mpac-ui';
import { useState } from 'react';
import { useAppBundlesById } from '../../controllers/useAppBundlesById';
import { BundleHeader } from './Header/BundleHeader';
import BundleOverview from './Overview/BundleOverview.tab';
import { makeBundleHeaderData, makeOverviewTabData } from './utils/bundle.utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BundleDetailPage = () => {
  const params = useParams();
  if (!params.appBundleId) {
    throw new Error('Bundle id is required');
  }
  const [tab, setTab] = useState('overview');
  const {
    data,
    error,
    loading
  } = useAppBundlesById({
    bundleId: params.appBundleId
  });
  if (!data && loading) {
    return /*#__PURE__*/_jsx("p", {
      children: "loading..."
    });
  }
  if (error) {
    return /*#__PURE__*/_jsxs("p", {
      "data-testid": "error-message",
      children: [JSON.stringify(error), "..."]
    });
  }
  const bundleHeaderData = data ? makeBundleHeaderData(data) : undefined;
  const overviewTabData = data ? makeOverviewTabData(data) : undefined;
  return /*#__PURE__*/_jsxs(FluidContainer, {
    children: [bundleHeaderData && /*#__PURE__*/_jsx(BundleHeader, _objectSpread({}, bundleHeaderData)), /*#__PURE__*/_jsx(ResponsiveTabs, {
      id: "bundle-detail-tabs",
      selected: tab,
      maxVisibleTabs: {
        xs: 2,
        sm: 4
      },
      onChange: tabData => setTab(tabData.key),
      tabs: [{
        label: 'Overview',
        content: overviewTabData ? /*#__PURE__*/_jsx(BundleOverview, _objectSpread({}, overviewTabData)) : null,
        key: 'overview'
      }, {
        label: 'Pricing',
        content: /*#__PURE__*/_jsx("div", {
          children: "Pricing"
        }),
        key: 'pricing'
      }, {
        label: 'Support',
        content: /*#__PURE__*/_jsx("div", {
          children: "support"
        }),
        key: 'support'
      }, {
        label: 'Installation',
        content: /*#__PURE__*/_jsx("div", {
          children: "Installation"
        }),
        key: 'installation'
      }]
    })]
  });
};
export { BundleDetailPage };